export default {
    messagesByJob() {
        return this.$store.state.unreadMessages.map(message => {
            return message.job.id
        })
    },

    replaceProfessionalMessage() {
        return this.$store.state.settings?.filter(setting => {
            return setting.id === 'replace_professional_message'
        })[0]?.value
    },

    resendJobInviteMessage() {
        return this.$store.state.settings?.filter(setting => {
            return setting.id === 'resend_job_invite_message'
        })[0]?.value
    },

    jobInviteResentMessage() {
        return this.$store.state.settings?.filter(setting => {
            return setting.id === 'job_invite_resent_message'
        })[0]?.value
    },

    acceptedJobCount() {
        return this.event?.jobs?.filter(job => job.status === 1)?.length || 0
    },

    pendingJobCount() {
        return this.event?.jobs?.filter(job => job.status === 0)?.length || 0
    },

    refusedJobCount() {
        return this.event?.jobs?.filter(job => job.status === 2)?.length || 0
    }
}
